module.exports = __webpack_public_path__ + "img/baac.77d5fddb.svg";